var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 11.1543H6.61111V12.0184H15.5625V11.1543Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68342 14.7285L9.32783 14.1525L7.02776 11.5806L9.33594 8.8396L8.67525 8.2832L5.88358 11.5975L8.68342 14.7285Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.5008C17.0652 22.5008 22 17.5661 22 11.5C22 5.43387 17.066 0.5 11 0.5C4.93403 0.5 0 5.43464 0 11.5C0 17.5654 4.93464 22.5008 11 22.5008ZM11 1.3642C16.5887 1.3642 21.1358 5.91126 21.1358 11.5C21.1358 17.0894 16.5887 21.6358 11 21.6358C5.41065 21.6358 0.864199 17.0887 0.864199 11.5C0.8645 5.91126 5.41157 1.3642 11 1.3642Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7734 11.1543H16.116V12.0184H17.7734V11.1543Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.3edbd04f868623fe424b0718f23f478c.svg";
export { ForwardRef as ReactComponent };